const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

const Tag = createClass({

  propTypes: {
    label: PropTypes.string,
    icon: PropTypes.string,
    className: PropTypes.string,
    onClose: PropTypes.func,
    active: PropTypes.bool,
    disabled: PropTypes.bool
  },

  render() {
    const {label, onClose, active, icon, className, disabled, ...other} = this.props;
    let classes = 'vf-tag';

    if (!disabled) classes = classes + ' vf-clickable';
    if (disabled) classes = classes + ' disabled';
    if (onClose) classes += ' -with-close';
    if (active) classes += ' active';
    if (className) classes += ' ' + className;

    return (
      <div className={classes} {...other}>
        {icon && (
          <span className={`margin-right-Hx icon icon-${icon}`} />
        )}
        <span className='vf-tag-label'>
          {label}
        </span>

        {onClose && <i className='vf-icon icon-close vf-clickable vf-close-tag' onClick={onClose} />}
      </div>
    );
  }
});

module.exports = Tag;
